module.exports = __webpack_public_path__ + "static/media/square.eb506239.svg";